export enum googleService {
  API_KEY = 'AIzaSyAh45IOKK2nyqx-_dSAGVBcmq0vSsWe4E0',
}
